exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faq .el-tabs {\n  padding-left: 20px;\n  margin-top: 20px;\n}\n", ""]);

// exports
